import { keys } from "./Keys";
import { RestError } from "../../services/rest-service/RestService";
import { BaseUseQueryParameters } from "../BaseUseQueryParameters";


import { useQuery } from "react-query";
import AlarmSchemeAdministrationDataService from "../../services/alarm-scheme-data-service/AlarmSchemeAdministrationService";
import { IReferenceDTO } from "../../services/alarm-scheme-data-service/Models";

export type UseAlarmSchemeReferenceDataParms = {
    groupID: number,
    organizationID: number,
} & BaseUseQueryParameters<IReferenceDTO | undefined>;

export function useAlarmSchemeReferenceData({
    groupID,
    organizationID,
    enabled,    
    onSuccess,
    onError
}: UseAlarmSchemeReferenceDataParms) {
    return useQuery<IReferenceDTO, RestError>(
        keys.referenceData(groupID, 
            organizationID,
        ),
        ({ signal }) => {
            return AlarmSchemeAdministrationDataService.getReferenceData(
                groupID, 
                organizationID,
                signal
            );
        },
        {
            enabled,
            onError: onError,
            onSuccess: onSuccess,
            //refetchInterval: refreshSeconds ? refreshSeconds * 1000 : false,
            refetchInterval: false,
            //staleTime: 0,
            staleTime: Infinity,
            refetchOnWindowFocus: false,
            refetchOnMount: true,
            refetchOnReconnect: false,
            retry: false,

        }
    );
}